import useResetPassword from 'pages/Auth/ResetPassword/useResetPassword'
import { FormikProvider } from 'formik'

import { useTranslation } from 'react-i18next'

import TextFieldFormik from 'components/TextFieldFormik'

import Heading from 'share-ui/components/Heading/Heading'

import { ButtonPrimary } from 'components/Button/Button'
import { StyledCenterFormContainer, StyledFormContainer } from '../ForgotPassword/ForgotPassword'
import { StyledRow } from 'pages/Subnets/panels/Playground/Subnets/Cortext/Settings/SettingsStyles.css'
import { StyledLogo } from 'pages/Navigation/MainNavigation'
import HeadingSecondary from 'components/Heading/Secondary'
import TypographySecondary from 'components/Typography/Secondary'

const ResetPassword = () => {
    const { t } = useTranslation()
    const { formik, resetPasswordLoading } = useResetPassword()

    return (
        <StyledCenterFormContainer>
            <StyledRow>
                <StyledLogo src={'/DaturaLogo.svg'} />

                <HeadingSecondary
                    value={t('datura-ai')}
                    type={Heading.types?.h2}
                    style={{ fontSize: 24, lineHeight: 'normal' }}
                />
            </StyledRow>
            <StyledFormContainer>
                <TypographySecondary size='small' value='Choose a new password for your account' />

                <FormikProvider value={formik}>
                    <TextFieldFormik
                        field_name='password'
                        placeholder={`${t('new-password')}*`}
                        type='password'
                    />
                    <TextFieldFormik
                        field_name='confirm_password'
                        placeholder={`${t('confirm-password')}*`}
                        type='password'
                    />
                </FormikProvider>
                <ButtonPrimary
                    onClick={formik.handleSubmit}
                    disabled={resetPasswordLoading}
                    loading={resetPasswordLoading}
                >
                    {t('update')}
                </ButtonPrimary>
            </StyledFormContainer>
        </StyledCenterFormContainer>
    )
}

export default ResetPassword
